import { Record, List } from 'immutable';
import { Utils, C } from '@kineticdata/bundle-common';
const { noPayload, withPayload } = Utils;
const ns = Utils.namespaceBuilder('app/catalog');

export const types = {
  FETCH_CATALOG_REQUEST: ns('FETCH_CATALOG_REQUEST'),
  FETCH_CATALOG_SUCCESS: ns('FETCH_CATALOG_SUCCESS'),
  FETCH_CATALOG_FAILURE: ns('FETCH_CATALOG_FAILURE'),
};

export const actions = {
  fetchCatalogRequest: noPayload(types.FETCH_CATALOG_REQUEST),
  fetchCatalogSuccess: withPayload(types.FETCH_CATALOG_SUCCESS),
  fetchCatalogFailure: withPayload(types.FETCH_CATALOG_FAILURE),
};

export const State = Record({
  init: false,
  loading: false,
  errors: List(),
  portfolios: List(),
  services: List(),
  appendices: List(),
  rateCards: List(),
});

const sortByName = item => item.values['Name'];
const sortBySortPriority = item => {
  const priority = item.values['Sort Priority']
    ? item.values['Sort Priority'].padStart(5, '0')
    : '99999';
  return `${priority}_${item.values['Name']}`;
};

const pickLatestVersion = (list, idField, sortFn) =>
  list
    .groupBy(p => p.values[idField])
    .map(l =>
      l
        .sortBy(p => p.updatedAt)
        .reverse()
        .first(),
    )
    .toList()
    .sortBy(sortFn || sortByName);

export const reducer = (state = State(), { type, payload }) => {
  switch (type) {
    case types.FETCH_CATALOG_REQUEST:
      return state.set('loading', true).set('error', List());
    case types.FETCH_CATALOG_SUCCESS:
      return state
        .set('init', true)
        .set('loading', false)
        .set(
          'portfolios',
          pickLatestVersion(
            List(payload.portfolios),
            C.FIELD_PORTFOLIO_ID,
            sortBySortPriority,
          ),
        )
        .set(
          'services',
          pickLatestVersion(
            List(payload.services),
            C.FIELD_SERVICE_ID,
            sortBySortPriority,
          ),
        )
        .set(
          'appendices',
          pickLatestVersion(
            List(payload.appendices),
            C.FIELD_APPENDIX_ID,
            sortByName,
          ),
        )
        .set('rateCards', List(payload.rateCards));
    case types.FETCH_CATALOG_FAILURE:
      return state
        .set('init', true)
        .set('loading', false)
        .set('errors', List(payload));
    default:
      return state;
  }
};
